import { render, staticRenderFns } from "./ConfigurationStockCategories.vue?vue&type=template&id=2f0def9b&scoped=true&"
import script from "./ConfigurationStockCategories.vue?vue&type=script&lang=js&"
export * from "./ConfigurationStockCategories.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationStockCategories.vue?vue&type=style&index=0&id=2f0def9b&prod&lang=css&"
import style1 from "./ConfigurationStockCategories.vue?vue&type=style&index=1&id=2f0def9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0def9b",
  null
  
)

export default component.exports